import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { TitleContainer } from '../../../../components/Css';
import Confetti from 'react-confetti';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { pageConfigs } from '../../configs/pageConfigs';
import { SuccessWrapperFinish, WrapperTitle } from './Finish.styles';
import { RouteEnum } from '../../constantes/RouteEnum';

const Finish: React.FC = () => {
  const navigate = useNavigate();
  const {isLoading, data: pageConfig = {}} = useGetTemplate('finish');
  const [showConfetti] = useState(true);
  
  const handleNext = () => {
    navigate(RouteEnum.HOME);
  }
  
  return (
    <PageContainer
      buttonText={pageConfigs.finish.labelNext}
      onClick={handleNext}
      loading={isLoading}
      thereIsButton
    >
      <WrapperTitle>
        <TitleContainer>{pageConfig.title}</TitleContainer>
      </WrapperTitle>
      
      <SuccessWrapperFinish>
        <div style={{margin: 'var(--spacing-regular)'}}>
          <DotLottieReact
            src="https://assets-v2.lottiefiles.com/a/d07e50ba-1177-11ee-b8dd-5f4b907dbc6e/XAbXh558A0.lottie"
            autoplay
            style={{width: '100%'}}
          />
        </div>
        
        {showConfetti && (
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            recycle={false}
          />
        )}
      </SuccessWrapperFinish>
    </PageContainer>
  );
};

export default Finish;
